import { render, staticRenderFns } from "./signUpInfo.vue?vue&type=template&id=520fbf1a&"
import script from "./signUpInfo.vue?vue&type=script&lang=js&"
export * from "./signUpInfo.vue?vue&type=script&lang=js&"
import style0 from "./signUpInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports